import React, { type FC } from 'react'

import styled from '@emotion/styled'

import { useIntl } from 'react-intl'
import { useRecoilCallback } from 'recoil'

import {
  BUTTON_VARIANT_SECONDARY,
  Button,
  Flex,
  HelpIcon,
} from 'mailup-web-components'

import { modalAddSegmentOpenCallback } from 'Pages/RecipientsList/recoil/callbacks/modalAddSegment'

const StyledHelpIcon = styled(HelpIcon)`
  pointer-events: all;

  align-self: center;
`

const ActionAddSegment: FC = () => {
  const intl = useIntl()

  const handleAddSegment = useRecoilCallback(modalAddSegmentOpenCallback, [])

  return (
    <Button
      kind={BUTTON_VARIANT_SECONDARY}
      data-mu-test="add-segment"
      onClick={handleAddSegment}
    >
      <Flex alignItems="center">
        <span>
          {intl.formatMessage({ id: 'Load.RecipientsList.SegmentAddCta' })}
        </span>

        <StyledHelpIcon
          inline={false}
          data-tip={intl.formatMessage({
            id: 'Load.RecipientsList.SegmentAddCtaTooltip',
          })}
        />
      </Flex>
    </Button>
  )
}

export default ActionAddSegment
